// extracted by mini-css-extract-plugin
module.exports = {"inputField":"inputField_6e7x6","fieldCaption":"fieldCaption_34z6q"};